import styled from 'styled-components'

import { style } from 'theme'

const Footnote = styled.div`
  color: ${style(theme => theme.colors.stone)};
  font-size: 12px;
  font-weight: 400;
  line-height: 1.33;
  margin: 0;
`

export default Footnote
